import { formatDate } from "date-fns";
import { FC } from "react";
import { IEventFeedResponse } from "@finbackoffice/websocket-client";
import classNames from "classnames";
import TeamIcon from "components/sport/base/team-icon/TeamIcon";
import { DEFAULT_DATE_FORMAT, useSportFeedType } from "hooks";
import { getSportClassName } from "utils/helpers";
import styles from "../home-sport-game-top.module.sass";

type Props = {
    game: IEventFeedResponse;
    index: number;
};

const TopInternational: FC<Props> = ({ game, index }) => {
    const { betProcessorFeedType } = useSportFeedType();

    return (
        <div
            className={classNames(
                styles.scoreboardTopInternational,
                getSportClassName(game.sport_id, betProcessorFeedType),
            )}>
            <div className={styles.internationalTeam}>
                <TeamIcon
                    sportId={game.sport_id}
                    teamId={game.home_team?.id}
                    priority={index === 0}
                />
                <b>{game.home_team?.name}</b>
            </div>
            {game.scheduled_at && (
                <div className={styles.internationalDate}>
                    {formatDate(new Date(game.scheduled_at), DEFAULT_DATE_FORMAT)}
                    <b>{formatDate(new Date(game.scheduled_at), "HH:mm")}</b>
                </div>
            )}
            <div className={styles.internationalName}>
                <b>{game.tournament_name}</b>
                {game.category_name}
            </div>
            <div className={styles.internationalTeam}>
                <TeamIcon
                    sportId={game.sport_id}
                    teamId={game.away_team?.id}
                    priority={index === 0}
                />
                <b>{game.away_team?.name}</b>
            </div>
        </div>
    );
};

export default TopInternational;
